import { router, RouterEvent } from '../service/router';
import { appConfig } from '../service/config';
import * as Logger from '@navigator/frontend-logger';

export class NavAppName extends HTMLElement {

  connectedCallback(): void {
    router.on('change', (event: RouterEvent) => {
      this.updateTitle(NavAppName.getAppName(event.next));
    });
  }

  static getAppName(path: string): string {
    let split = path.split('/');
    let appName = '';
    if (split[1]) {
      appName = split[1];
    }
    split = appName.split('?');
    if (split[1]) {
      appName = split[0];
    }
    split = appName.split('#');
    if (split[1]) {
      appName = split[0];
    }

    return appName;
  }

  updateTitle(appName: string): void {
    if (!appName) {
      appName = appConfig.core.defaultRoute;
    }
    let logoTitle;
    if (appConfig.thirdParty.navigator.apps[appName] && appConfig.thirdParty.navigator.apps[appName].logo_title) {
      logoTitle = appConfig.thirdParty.navigator.apps[appName].logo_title;
    } else {
      Logger.error(`Could not find the logo title for "${appName}" in the config.`);
    }
    this.innerText = logoTitle;
    this.setAttribute('aria-label', logoTitle);
  }

}

window.customElements.define('nav-app-name', NavAppName);
